import React from "react";
import { Switch } from "react-router-dom";
import AuthLayout from "../app/layout/authLayout";
import Company from "../app/views/company";
import ProductForm from "../app/views/company/add/products-and-technologies/components";
import CompanyUI from "../app/views/company/add";
import ProductDetail from "../app/views/company/add/products-and-technologies/components/overview/product-detail-description";
import CollaborationListing from "../app/views/company/add/collaboration";
import CollaborationForm from "../app/views/company/add/collaboration/add";
import VideoModal from "app/views/company/add/products-and-technologies/components/overview/videos/videoModal";
import CompanyBasicVideo from "app/views/company/add/basic/components/videos";
import CompanyBasicAddress from "app/views/company/add/basic/components/address";
import CompanyBasicFunding from "app/views/company/add/basic/components/funding";
import CompanyBasicRevenue from "app/views/company/add/basic/components/revenue";
import CompanyBasicInvestment from "app/views/company/add/basic/components/investments";
import CompanyBasicOverview from "app/views/company/add/basic/components/overview";
import TechnicalSpecsModal from "app/views/company/add/products-and-technologies/components/technical-specification/add";
import ImageModal from "app/views/company/add/products-and-technologies/components/overview/images/imageModal";
import DocumentModal from "app/views/company/add/products-and-technologies/components/overview/documents-brochure/documentModal";
import CompanyBasicDocument from "app/views/company/add/basic/components/documents";
import DataProcessing from "../app/views/dataProcessing/company";
import DataScreeningCompany from "../app/views/dataScreening/company";
import DataAllocationCompany from "../app/views/dataAllocation/company";
import DataProcessingCompany from "../app/views/dataProcessing/company/companyTabs";
const SELECT = ["Select:VIEW", "Select:FULL"];
const REJECT = ["Reject:VIEW", "Reject:FULL"];
const HOLD = ["Hold:VIEW", "Hold:FULL"];
const IMPORT = ["Import:VIEW", "Import:FULL"];
const EXPORT = ["Export:VIEW", "Export:FULL"];
const ALLOCATION = ["Allocation:VIEW", "Allocation:FULL"];
const BASIC = ["Basic:VIEW", "Basic:FULL"];
const ADVANCED = ["Advanced:VIEW", "Advanced:FULL"];
const PRODUCTS = ["Products & Technologies:VIEW", "Products & Technologies:FULL"];
const COLLABORATION = ["Collaboration:VIEW", "Collaboration:FULL"];
const TAXONOMY = ["Taxonomy:VIEW", "Taxonomy:FULL"];
const PROCESSING = ["Processing:VIEW", "Processing:FULL"];

const CompanyRoutes = () => (
  <Switch>
    <AuthLayout
      exact
      path="/company"
      component={Company}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC, ...ADVANCED, ...PRODUCTS, ...COLLABORATION, ...TAXONOMY],
        interfaceName: "Listing",
      }}
    />
    <AuthLayout
      exact
      path="/company/add"
      component={CompanyUI}
      pageHeading="GenNx CMS - Company"
      editData={false}
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/edit"
      component={CompanyUI}
      pageHeading="GenNx CMS - Company"
      editData={true}
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC, ...ADVANCED, ...PRODUCTS, ...COLLABORATION, ...TAXONOMY],
        interfaceName: "Basic",
      }}
    />
      <AuthLayout
        exact
        path="/company/:companyId/product/add"
        component={ProductForm}
        pageHeading="GenNx CMS - Products & Technology"
        editData={false}
        accessRights={{
          moduleName: "Products & Technology",
          parentModuleName: "Company",
          moduleAttribute: [...PRODUCTS],
          interfaceName: "Overview",
        }}
      />
    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/edit"
      component={ProductForm}
      pageHeading="GenNx CMS - Products & Technology"
      editData={true}
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/product/product-detail-description/add"
      component={ProductDetail}
      editData={false}
      pageHeading="GenNx CMS - Product Detail & Description"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/product-detail-description/edit"
      component={ProductDetail}
      editData={true}
      pageHeading="GenNx CMS - Product Detail & Description"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />

    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/document/add"
      component={DocumentModal}
      editData={false}
      pageHeading="GenNx CMS - Documents/Brochure"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/document/:documentId/edit"
      component={DocumentModal}
      editData={true}
      pageHeading="GenNx CMS - Documents/Brochure"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />

    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/video/add"
      component={VideoModal}
      editData={false}
      pageHeading="GenNx CMS - Videos"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/video/:videoId/edit"
      component={VideoModal}
      editData={true}
      pageHeading="GenNx CMS - Videos"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/image/add"
      component={ImageModal}
      editData={false}
      pageHeading="GenNx CMS - Images"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/image/:imageId/edit"
      component={ImageModal}
      editData={true}
      pageHeading="GenNx CMS - Images"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/technical-specification/add"
      component={TechnicalSpecsModal}
      editData={false}
      pageHeading="GenNx CMS - Technical Specifications"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/product/:productId/technical-specification/:techSpecsId/edit"
      component={TechnicalSpecsModal}
      editData={true}
      pageHeading="GenNx CMS - Technical Specifications"
      accessRights={{
        moduleName: "Products & Technology",
        parentModuleName: "Company",
        moduleAttribute: [...PRODUCTS],
        interfaceName: "Overview",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/collaboration"
      component={CollaborationListing}
      pageHeading="GenNx CMS - Collaboration"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...COLLABORATION],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/collaboration/:collaborationId/edit"
      component={CollaborationForm}
      pageHeading="GenNx CMS - Collaboration"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...COLLABORATION],
        interfaceName: "Collaboration",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/collaboration/add"
      component={CollaborationForm}
      pageHeading="GenNx CMS - Collaboration"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...COLLABORATION],
        interfaceName: "Collaboration",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/video/add"
      component={CompanyBasicVideo}
      editData={false}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/video/:videoId/edit"
      component={CompanyBasicVideo}
      editData={true}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/address/add"
      component={CompanyBasicAddress}
      editData={false}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/address/:addressId/edit"
      component={CompanyBasicAddress}
      editData={true}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/documents/add"
      component={CompanyBasicDocument}
      editData={false}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/documents/:documentId/edit"
      component={CompanyBasicDocument}
      editData={true}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/funding/add"
      component={CompanyBasicFunding}
      editData={false}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/funding/:fundingId/edit"
      component={CompanyBasicFunding}
      editData={true}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/revenue/add"
      component={CompanyBasicRevenue}
      editData={false}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/revenue/:revenueId/edit"
      component={CompanyBasicRevenue}
      editData={true}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/investment/add"
      component={CompanyBasicInvestment}
      editData={false}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/investment/:investmentId/edit"
      component={CompanyBasicInvestment}
      editData={true}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/overview/add"
      component={CompanyBasicOverview}
      editData={false}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/company/:companyId/overview/edit"
      component={CompanyBasicOverview}
      editData={true}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/processing/company"
      component={DataProcessing}
      pageHeading="GenNx CMS - Company - Processing"
      accessRights={{
        moduleName: "Processing",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC, ...ADVANCED, ...PRODUCTS, ...COLLABORATION, ...TAXONOMY, ...PROCESSING],
        interfaceName: "Listing",
      }}
    />
    <AuthLayout
      exact
      path="/data-screening/company"
      component={DataScreeningCompany}
      pageHeading="GenNx CMS - Company - Screening"
      accessRights={{
        moduleName: "Screening",
        parentModuleName: "Company",
        moduleAttribute: [...SELECT, ...REJECT, ...HOLD, ...IMPORT, ...EXPORT],
        interfaceName: "Listing",
      }}
    />
    <AuthLayout
      exact
      path="/allocation/company"
      component={DataAllocationCompany}
      pageHeading="GenNx CMS - Company - Allocation"
      accessRights={{
        moduleName: "Allocation",
        parentModuleName: "Company",
        moduleAttribute: [...ALLOCATION],
        interfaceName: "Listing",
      }}
    />
    <AuthLayout
      exact
      path="/processing/company/add"
      component={DataProcessingCompany}
      pageHeading="GenNx CMS - Company"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC, ...PROCESSING],
        interfaceName: "Basic",
      }}
    />
    <AuthLayout
      exact
      path="/processing/company/:companyId/edit"
      component={DataProcessingCompany}
      pageHeading="GenNx CMS - Company - Processing"
      accessRights={{
        moduleName: "Company",
        parentModuleName: "Company",
        moduleAttribute: [...BASIC, ...ADVANCED, ...COLLABORATION, ...TAXONOMY, ...PROCESSING],
        interfaceName: "Basic",
      }}
    />
  </Switch>
);

export default CompanyRoutes;
